import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiUserPlus, FiEye, FiEyeOff, FiAlertCircle } from "react-icons/fi";
import { useCustomer } from "../context/ShopContext";
import "./Cart.css";

const PROVINCES = ["Gauteng","Western Cape","KwaZulu-Natal","Eastern Cape","Limpopo","Mpumalanga","North West","Free State","Northern Cape"];

export default function RegisterPage() {
  const { login }  = useCustomer();
  const navigate   = useNavigate();
  const [showPw, setShowPw]   = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");
  const [form, setForm] = useState({
    first_name: "", last_name: "", email: "", phone: "",
    password: "", password2: "",
    address: "", city: "", province: "", postal_code: "",
  });

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password2) { setError("Passwords do not match."); return; }
    setLoading(true); setError("");
    try {
      const r = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.message || "Registration failed.");
      login(data.customer, data.token);
      navigate("/account/orders");
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <main style={{ minHeight: "100vh", background: "#f4f4f7", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 16px", fontFamily: "'DM Sans', sans-serif" }}>
      <div className="cart-auth" style={{ maxWidth: 520, width: "100%" }}>
        <div className="cart-auth__header">
          <h2>Create Account</h2>
          <p>Register for faster checkout and order tracking.</p>
        </div>
        <form className="cart-auth__form cart-form" onSubmit={handleSubmit}>
          {error && <p className="cart-error cart-form__group--full"><FiAlertCircle size={14} /> {error}</p>}
          <div className="cart-form__group"><label>First name *</label><input required value={form.first_name} onChange={set("first_name")} /></div>
          <div className="cart-form__group"><label>Last name *</label><input required value={form.last_name} onChange={set("last_name")} /></div>
          <div className="cart-form__group"><label>Email *</label><input type="email" required value={form.email} onChange={set("email")} /></div>
          <div className="cart-form__group"><label>Phone</label><input value={form.phone} onChange={set("phone")} /></div>
          <div className="cart-form__group">
            <label>Password *</label>
            <div className="cart-pw-wrap">
              <input type={showPw ? "text" : "password"} required value={form.password} onChange={set("password")} placeholder="Min. 8 characters" />
              <button type="button" className="cart-pw-toggle" onClick={() => setShowPw(v => !v)}>
                {showPw ? <FiEyeOff size={15} /> : <FiEye size={15} />}
              </button>
            </div>
          </div>
          <div className="cart-form__group"><label>Confirm password *</label><input type={showPw ? "text" : "password"} required value={form.password2} onChange={set("password2")} placeholder="Re-enter password" /></div>
          <div className="cart-form__group cart-form__group--full"><label>Street address</label><input value={form.address} onChange={set("address")} /></div>
          <div className="cart-form__group"><label>City</label><input value={form.city} onChange={set("city")} /></div>
          <div className="cart-form__group">
            <label>Province</label>
            <select value={form.province} onChange={set("province")}>
              <option value="">Select…</option>
              {PROVINCES.map(p => <option key={p}>{p}</option>)}
            </select>
          </div>
          <div className="cart-form__group"><label>Postal code</label><input value={form.postal_code} onChange={set("postal_code")} /></div>
          <button className="cart-btn cart-btn--primary cart-btn--full cart-form__group--full" disabled={loading}>
            <FiUserPlus size={15} /> {loading ? "Creating account…" : "Create Account"}
          </button>
          <p className="cart-auth__switch cart-form__group--full">
            Already have an account? <Link to="/login" style={{ color: "#d62828", fontWeight: 700 }}>Sign in</Link>
          </p>
          <p className="cart-auth__switch cart-form__group--full">
            <Link to="/shop" style={{ color: "#888", fontSize: "0.82rem" }}>← Back to shop</Link>
          </p>
        </form>
      </div>
    </main>
  );
}